import { useSearchParams } from 'react-router';
import type { AttributeValue } from '@gonfalon/experiments/types';

export type AttributeFilterState = {
  selectedAttributeName?: string;
  selectedAttributeValues: { [attributeName: string]: AttributeValue[] };
};

// encapsulates search param read logic
export function useAttributeFilter() {
  const [searchParams] = useSearchParams();
  const name = searchParams.get('attribute');
  const values = searchParams.get('values')?.split('&') ?? [];

  return name === null
    ? undefined
    : {
        name,
        values,
      };
}
